import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "defective-parts-section" }
const _hoisted_2 = {
  key: 1,
  class: "cards"
}
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "card-header" }
const _hoisted_5 = ["aria-expanded", "onClick"]
const _hoisted_6 = { class: "title" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "collapse-inner" }
const _hoisted_9 = {
  key: 0,
  class: "summary"
}
const _hoisted_10 = { class: "collapse-inner" }
const _hoisted_11 = { class: "card-form" }
const _hoisted_12 = ["onUpdate:modelValue", "disabled", "max", "onInput"]
const _hoisted_13 = {
  key: 0,
  class: "error"
}
const _hoisted_14 = ["onUpdate:modelValue", "disabled", "onInput"]
const _hoisted_15 = {
  key: 0,
  class: "error"
}
const _hoisted_16 = { class: "article" }
const _hoisted_17 = ["disabled", "onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 0,
  class: "article-number"
}
const _hoisted_20 = {
  key: 1,
  class: "error"
}
const _hoisted_21 = ["onUpdate:modelValue", "aria-invalid", "disabled", "onInput"]
const _hoisted_22 = {
  key: 0,
  class: "error"
}
const _hoisted_23 = ["aria-expanded", "onClick"]
const _hoisted_24 = {
  key: 2,
  class: "warning",
  role: "alert"
}
const _hoisted_25 = { class: "modal-content article-modal" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "product-information" }
const _hoisted_28 = { class: "sku" }
const _hoisted_29 = { class: "product-name" }
const _hoisted_30 = {
  key: 0,
  class: "no-products-to-show"
}
const _hoisted_31 = {
  key: 1,
  class: "more-matches"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_loader = _resolveComponent("base-loader")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_card_modal = _resolveComponent("card-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_base_loader, { key: 0 }))
      : _createCommentVNode("", true),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cards, (card) => {
            return (_openBlock(), _createElementBlock("li", {
              id: `defective-card-${card.key}`,
              key: card.key,
              class: _normalizeClass([{ open: card.open, problem: _ctx.warningKey === card.key }, "card"])
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("button", {
                  "aria-expanded": card.open,
                  class: "card-toggle",
                  type: "button",
                  onClick: ($event: any) => (card.open = !card.open)
                }, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.titleOf(card)), 1)
                ], 8, _hoisted_5),
                (_ctx.editable)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      "aria-label": "Verwijderen",
                      class: "cross",
                      type: "button",
                      onClick: ($event: any) => (_ctx.remove(card))
                    }, [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("svg", {
                        fill: "none",
                        height: "16",
                        viewBox: "0 0 16 16",
                        width: "16",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M3 3L13 13M13 3L3 13",
                          stroke: "currentColor",
                          "stroke-linecap": "round",
                          "stroke-width": "1.5"
                        })
                      ], -1)
                    ]))], 8, _hoisted_7))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass([{ shown: !card.open }, "collapse"])
              }, [
                _createElementVNode("div", _hoisted_8, [
                  (_ctx.isFilled(card))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.summaryOf(card)), 1))
                    : _createCommentVNode("", true)
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass([{ shown: card.open }, "collapse"])
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("label", null, [
                      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "label" }, "Datum", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": ($event: any) => ((card.form.replaced_at) = $event),
                        class: _normalizeClass([{ invalid: card.errors.replaced_at }, "field"]),
                        disabled: !_ctx.editable,
                        max: _ctx.today,
                        type: "date",
                        onInput: ($event: any) => (_ctx.touch(card, 'replaced_at'))
                      }, null, 42, _hoisted_12), [
                        [_vModelText, card.form.replaced_at]
                      ]),
                      (card.errors.replaced_at)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(card.errors.replaced_at), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("label", null, [
                      _cache[6] || (_cache[6] = _createElementVNode("span", { class: "label" }, "Serienummer", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": ($event: any) => ((card.form.serial_number) = $event),
                        class: _normalizeClass([{ invalid: card.errors.serial_number }, "field"]),
                        disabled: !_ctx.editable,
                        inputmode: "text",
                        placeholder: "Serienummer waterontharder",
                        type: "text",
                        onInput: ($event: any) => (_ctx.touch(card, 'serial_number'))
                      }, null, 42, _hoisted_14), [
                        [_vModelText, card.form.serial_number]
                      ]),
                      (card.errors.serial_number)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(card.errors.serial_number), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _cache[8] || (_cache[8] = _createElementVNode("span", { class: "label" }, "Defecte artikel", -1)),
                      _createElementVNode("div", {
                        class: _normalizeClass([{ invalid: card.errors.article, empty: !card.form.article, disabled: !_ctx.editable }, "field select"])
                      }, [
                        _createElementVNode("button", {
                          disabled: !_ctx.editable,
                          class: "select-value",
                          type: "button",
                          onClick: ($event: any) => (_ctx.openPicker(card))
                        }, _toDisplayString(card.form.article || 'Kies het defecte artikel'), 9, _hoisted_17),
                        (_ctx.editable && card.form.article)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              "aria-label": "Artikel wissen",
                              class: "clear",
                              type: "button",
                              onClick: ($event: any) => (_ctx.clearArticle(card))
                            }, [...(_cache[7] || (_cache[7] = [
                              _createElementVNode("svg", {
                                fill: "none",
                                height: "16",
                                viewBox: "0 0 16 16",
                                width: "16",
                                xmlns: "http://www.w3.org/2000/svg"
                              }, [
                                _createElementVNode("path", {
                                  d: "M3 3L13 13M13 3L3 13",
                                  stroke: "currentColor",
                                  "stroke-linecap": "round",
                                  "stroke-width": "1.5"
                                })
                              ], -1)
                            ]))], 8, _hoisted_18))
                          : _createCommentVNode("", true)
                      ], 2),
                      (card.form.article_number)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Artikelnummer " + _toDisplayString(card.form.article_number), 1))
                        : _createCommentVNode("", true),
                      (card.errors.article)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(card.errors.article), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("label", null, [
                      _cache[9] || (_cache[9] = _createElementVNode("span", { class: "label" }, "Wat was de storing of foutcode?", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": ($event: any) => ((card.form.comment) = $event),
                        "aria-invalid": !!card.errors.comment,
                        class: _normalizeClass([{ invalid: card.errors.comment }, "field"]),
                        disabled: !_ctx.editable,
                        rows: "3",
                        onInput: ($event: any) => (_ctx.touch(card, 'comment'))
                      }, null, 42, _hoisted_21), [
                        [_vModelText, card.form.comment]
                      ]),
                      (card.errors.comment)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(card.errors.comment), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ], 2),
              _createElementVNode("button", {
                "aria-expanded": card.open,
                class: "card-action",
                type: "button",
                onClick: ($event: any) => (card.open = !card.open)
              }, [
                _createTextVNode(_toDisplayString(card.open ? 'Inklappen' : (_ctx.editable ? 'Gegevens wijzigen' : 'Gegevens bekijken')) + " ", 1),
                (_openBlock(), _createElementBlock("svg", {
                  class: _normalizeClass([{ open: card.open }, "chevron"]),
                  fill: "none",
                  height: "16",
                  viewBox: "0 0 16 16",
                  width: "16",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [...(_cache[10] || (_cache[10] = [
                  _createElementVNode("path", {
                    d: "M4 6L8 10L12 6",
                    stroke: "currentColor",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "1.5"
                  }, null, -1)
                ]))], 2))
              ], 8, _hoisted_23)
            ], 10, _hoisted_3))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.warning)
      ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(_ctx.warning), 1))
      : _createCommentVNode("", true),
    (_ctx.editable && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("button", {
          key: 3,
          class: "btn secondary full-width ion-activatable ripple-parent add",
          type: "button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.add && _ctx.add(...args)))
        }, [
          _cache[11] || (_cache[11] = _createTextVNode(" + Onderdeel toevoegen ", -1)),
          _createVNode(_component_ion_ripple_effect)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_card_modal, {
      ref: "articleModal",
      title: 'Defecte artikel',
      backdrop: "",
      closable: ""
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_ion_searchbar, {
            modelValue: _ctx.search,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
            class: "search-bar",
            debounce: "150",
            inputmode: "search",
            mode: "ios",
            placeholder: "Zoek op naam of artikelnummer"
          }, null, 8, ["modelValue"]),
          _createElementVNode("ul", {
            class: "product-list",
            onMousedown: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
            onTouchstartPassive: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.matches, (product) => {
              return (_openBlock(), _createElementBlock("li", {
                key: product.id,
                class: "product-item ion-activatable ripple-parent",
                onClick: ($event: any) => (_ctx.pick(product))
              }, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("span", _hoisted_28, _toDisplayString(product.sku), 1),
                  _createElementVNode("span", _hoisted_29, _toDisplayString(product.name), 1)
                ]),
                _createVNode(_component_ion_ripple_effect)
              ], 8, _hoisted_26))
            }), 128)),
            (_ctx.matches.length === 0)
              ? (_openBlock(), _createElementBlock("li", _hoisted_30, "Geen product gevonden"))
              : (_ctx.hasMoreMatches)
                ? (_openBlock(), _createElementBlock("li", _hoisted_31, "Typ verder om meer producten te zien"))
                : _createCommentVNode("", true)
          ], 32)
        ])
      ]),
      _: 1
    }, 512)
  ]))
}